import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CustomNavbar from "../../../components/CustomNavbar";
//import SibebarSeleccionContratacion from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import comp from "../../../images/Modulo carrera y sucesion/pngegg.png";
import SidebarCarreraSucesion from "../../../components/Carrera_Sucesion/SidebarCarreraSucesion";
import { Link } from "react-router-dom";

const Admin = () => {
  const [show, setShow] = useState(true);
  //* Method
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCarreraSucesion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="jumbotron ft-banner">
            <main>
              <h1>Sucesión</h1>
              <p className="mb-4 text-muted">
                El módulo de sucesión tiene por objetivo la
                visualización de automatizar el proceso de planes de sucesión de
                todos los colaboradores{" "}
              </p>
              <Row>
                <Col>
                  <h4>Mantenimientos sucesión</h4>
                  <ul className="ml-3 p-0">
                    
                    {/* <li>
                      <Link to="/sucesion/criticidad">
                        Mantenimiento de criticidad
                      </Link>
                    </li> */}
                    <li>
                      <Link to="/sucesion/factores-criticidad">
                        Mantenimiento de factores de criticidad
                      </Link>
                    </li>
                    
                    <li>
                      <Link to="/sucesion/tipo-criticidad">
                      Mantenimiento de tipo criticidad
                      </Link>
                    </li>
                    <li>
                      <Link to="/sucesion/cursos">
                      Mantenimiento de cursos
                      </Link>
                    </li>
                    <li>
                      <Link to="/sucesion/cursos-funcion">
                      Mantenimiento de cursos funciones
                      </Link>
                    </li>
                    
                    
                    <li>
                      <Link to="/sucesion/criterios">
                        Mantenimiento de criterios
                      </Link>
                    </li>
                    <li>
                      <Link to="/sucesion/factores-criterios">
                        Mantenimiento de factores criterios
                      </Link>
                    </li>
                    <li>
                      <Link to="/sucesion/factores-responsables">
                        Mantenimiento de factores responsables
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </main>
            <div className="figure">
              <img src={comp} alt="descriptores y perfiles" className="my-3" />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Admin;
